export function DocPageHeader({
  section,
  title,
  description,
}: {
  section: string
  title: string
  description: string
}) {
  return (
    <div className="mb-10">
      <p className="text-sm font-semibold uppercase tracking-wider text-primary mb-3">{section}</p>
      <h1
        className="text-4xl font-bold text-foreground mb-4"
        style={{ fontFamily: 'var(--font-heading)' }}
      >
        {title}
      </h1>
      <p className="text-lg text-muted-foreground leading-relaxed">{description}</p>
    </div>
  )
}
